const MONTHS = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'] as const

/**
 * A moment exactly as the API's connector alerts write one — Python's
 * `%d %b %Y %H:%M UTC`, e.g. `05 Sep 2026 14:23 UTC` — so a health card and the
 * Overview alert that led to it name the same moment the same way. Built from
 * the UTC fields rather than `Intl`, whose en-GB short month for September is
 * "Sept".
 */
export function utcLabel(moment: Date | string): string {
  const at = new Date(moment)
  const pad = (value: number) => String(value).padStart(2, '0')
  const date = `${pad(at.getUTCDate())} ${MONTHS[at.getUTCMonth()]} ${at.getUTCFullYear()}`
  return `${date} ${pad(at.getUTCHours())}:${pad(at.getUTCMinutes())} UTC`
}
